// extracted by mini-css-extract-plugin
export var bottomCircle = "bM_hq";
export var content = "bM_bx";
export var description = "bM_dn";
export var hide = "bM_z";
export var icon = "bM_bv";
export var image = "bM_g";
export var imageContainer = "bM_hv";
export var left = "bM_bN";
export var nextYear = "bM_ht";
export var right = "bM_cl";
export var section = "bM_d";
export var shrink = "bM_hs";
export var title = "bM_h";
export var topCircle = "bM_hp";
export var wave = "bM_gq";
export var waveContainer = "bM_d7";
export var year = "bM_hr";